// Tabs/TabPanelContent.disorders_diceases.tsx
import React from 'react';
import TherapeuticIndicatorsTableCard from '../components/tabs/disorders_diseases/TherapeuticalIndicatorsTable';
import PubchemClinicalTrialsTableCard from '../components/tabs/disorders_diseases/PubchemClinicalTrials';
import ClinicalTrialsTableCard from '../components/tabs/disorders_diseases/ClinicalTrialsTable';
import PubChemTableCard from '../components/tabs/compounds/PubchemTable';
import TherapeuticalIndicatorCard from '../components/tabs/disorders_diseases/TherapeuticalIndicator';
import ClinicalTrialCard from '../components/tabs/disorders_diseases/ClinicalTrial';
import DynamicTabContentTable from './DynamicTabContentTable';

interface TabPanelContentProps {
    dynamicCollections: any[];
}

const TabPanelContentDisordersDiseases: React.FC<TabPanelContentProps> = ({ dynamicCollections }) => (
    <div className="row">
        <div className="col-9 col-sm-9">
            <TherapeuticIndicatorsTableCard header={'Therapeutic Indications'} eventGroupToTrigger={'disorders_diceases'} />
            <PubchemClinicalTrialsTableCard header={'PUBCHEM - Clinical Trials'} eventGroupToTrigger={'disorders_diceases'} />
            <ClinicalTrialsTableCard header={'Clinical Trials GOV'} eventGroupToTrigger={'disorders_diceases'} />
            <PubChemTableCard header={'PUBCHEM - Disorders + Diseases'} storageValue={'disorders_diceases'} eventGroupToTrigger={'disorders_diceases'} />
            <DynamicTabContentTable dynamicCollections={dynamicCollections} tabName="disorders_diceases" />
        </div>
        <div className="col-3 col-sm-3">
            <TherapeuticalIndicatorCard header={'Therapeutical Indications'} eventGroupToTrigger={'disorders_diceases'} />
            <ClinicalTrialCard header={'Clinical Trial'} eventGroupToTrigger={'disorders_diceases'} />
        </div>
    </div>
);

export default TabPanelContentDisordersDiseases;
